'use client';

import clsx from 'clsx';
import { GlowImage } from '@headless-workspace/glow-ds';
import { ObjectHelpers } from '@headless-workspace/utils';
import { createPortal } from 'react-dom';
import { useIsClient } from 'usehooks-ts';

const IMAGE_HEIGHT = 60;
const IMAGE_WIDTH = 40;

const ProductDetailInformationLoaderClass = 'product-loader';
const ProductDetailInformationLoaderSvgId = 'product-loader-svg';

export const ProductInformationLoader = () => {
    const isCLient = useIsClient();

    return (
        isCLient &&
        createPortal(
            <div
                className={clsx(
                    ProductDetailInformationLoaderClass,
                    'inset-0 w-full h-full bg-background-overlay fixed z-[20] flex justify-center items-center select-none',
                )}
            >
                <GlowImage
                    id={ProductDetailInformationLoaderSvgId}
                    image={ObjectHelpers.createImageWithSrc('/images/loaderSephora.svg')}
                    height={IMAGE_HEIGHT}
                    width={IMAGE_WIDTH}
                />
            </div>,
            document.body,
        )
    );
};

export default ProductInformationLoader;
